import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import ExternalLinkViewer from "./global-components/external-link-viewer";

const ADConstraints = ({ onOK, project }) => {
  const { t } = useTranslation();
  const [externalLinkViewer, setExternalLinkViewer] = useState({ open: false, fileUrl: '' });

  return (
    <div className='custom-card ad-constraints'>
      <div className='card-header'>
        <h4>{t("RealEstateAdvertisingControls")}</h4>
        <h6>{t("OnceYouClickNextYouAgreeToAllOfTheseTermsAndConditions")}</h6>
      </div>
      <div className='card-body'>
        <div>
          <ul>
            <li>{t("TheADInformationIsCorrect")}</li>
            <li>{t("TheRealEstateADMustBeRemovedAfterPurposeHasBeenFulfilled")}</li>

            {!project && (
              <>
                <li>{t("TheADWillBeAutomaticallyDeletedAccordingToTheExpirationDateOfTheAdvertisementLicense")}</li>
                <li>{t("TheADWillBeBlockedIfTheLicenseOfFALBrokerageAndMarketingExpires")}</li>
              </>
            )}

            <li>
              {t("AdherenceToAllProvisions4")}
              <span
                style={{ color: "var(--main-color-one)", textDecoration: "underline", cursor: 'pointer' }}
                onClick={() => setExternalLinkViewer({ open: true, fileUrl: 'https://amakknbackendupload.s3.me-south-1.amazonaws.com/brokerage.pdf' })}
              >
                {t("AdherenceToAllProvisions5")}
              </span>
              {t("AND")}
              <span
                style={{ color: "var(--main-color-one)", textDecoration: "underline", cursor: 'pointer' }}
                onClick={() => setExternalLinkViewer({ open: true, fileUrl: 'https://amakknbackendupload.s3.me-south-1.amazonaws.com/regulations.pdf' })}
              >
                {t("AdherenceToAllProvisions6")}
              </span>
           
            </li>
            <li> {t("AdherenceToAllProvisions1")}
            
              <span
                style={{ color: "var(--main-color-one)", textDecoration: "underline", cursor: 'pointer' }}
                onClick={() => setExternalLinkViewer({ open: true, fileUrl: 'https://amakknbackendupload.s3.me-south-1.amazonaws.com/rega.pdf' })}
              >
                {t("AdherenceToAllProvisions2")}
              </span>
              {t("AdherenceToAllProvisions3")}
            </li>
            <li>
              {t("IAgreeToTheTermsAndConditionsOfTheAmakknPlatformUsageAgreement1")}
              <span
                style={{ color: "var(--main-color-one)", textDecoration: "underline", cursor: 'pointer' }}
                onClick={() => setExternalLinkViewer({ open: true, fileUrl: 'terms' })}
              >
                {t("IAgreeToTheTermsAndConditionsOfTheAmakknPlatformUsageAgreement2")}
              </span>
              .
            </li>
          </ul>
        </div>
      </div>
      <div className='card-footer'>
        <button className='primary-btn px-5' onClick={() => onOK()}>
          {t("Next")}
        </button>
      </div>
      
      <ExternalLinkViewer
        open={externalLinkViewer?.open}
        fileUrl={externalLinkViewer?.fileUrl}
        setOpen={() => setExternalLinkViewer({
          open: false,
          fileUrl: ''
        })}
      />
    </div>
  );
}

export default ADConstraints;
